import React from "react";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "../firebase";

const AuthContext = React.createContext()

const AuthContextProvider = ({ children }) => {
   const [user, setUser] = React.useState(null)

   React.useEffect(() => {
      const unsubscribe = onAuthStateChanged(auth, (user) => {
         setUser(user)
      })

      return () => {
         unsubscribe()
      }
   }, [])

   return (
      <AuthContext.Provider value={{ user, setUser }}>
         {children}
      </AuthContext.Provider>
   )
}

const useAuth = () => {
   const context = React.useContext(AuthContext)

   if (!context) {
      throw new Error('useAuth should be used inside the AuthContextProvider')
   }

   return context
}

export { AuthContextProvider, useAuth }